import { render, staticRenderFns } from "./TqRiddleData_Edit.vue?vue&type=template&id=cce4cabc&scoped=true&"
import script from "./TqRiddleData_Edit.vue?vue&type=script&lang=js&"
export * from "./TqRiddleData_Edit.vue?vue&type=script&lang=js&"
import style0 from "./TqRiddleData_Edit.vue?vue&type=style&index=0&id=cce4cabc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce4cabc",
  null
  
)

export default component.exports